import React from 'react'
import { AuthProvider } from './src/utils/useAuth'
import { ApolloProvider } from '@apollo/client'
import { WindowWidthProvider } from './src/utils/useWindowWidth'
import { client } from './src/apollo/client'
import EditResourceProvider from './src/context/EditContext'
import QuestionStepProvider from './src/context/QuestionStepContext'
import ArticleProvider from './src/context/ArticleContext'
import StrategyOverviewCardsProvider from './src/context/StrategyOverviewCardsContext'
import theme from './src/gatsby-plugin-theme-ui/index'
import { ThemeProvider } from 'theme-ui'
import { GlobalStateProvider } from './src/utils/useGlobalState'
import SnackbarProvider from 'react-simple-snackbar'
import PageNumberProvider from './src/context/PageNumberContext'
import MaintenancePackageProvider from './src/context/MaintenancePackageContext'
import CalendarArticleProvider from './src/context/CalendarArticleContext'

// Context values must wrap the element in this component.
// https://www.gatsbyjs.com/blog/2019-01-31-using-react-context-api-with-gatsby/
export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <WindowWidthProvider>
          <EditResourceProvider>
            <CalendarArticleProvider>
              <QuestionStepProvider>
                <StrategyOverviewCardsProvider>
                  <ArticleProvider>
                    <SnackbarProvider>
                      <GlobalStateProvider>
                        <PageNumberProvider>
                          <MaintenancePackageProvider>
                            {element}
                          </MaintenancePackageProvider>
                        </PageNumberProvider>
                      </GlobalStateProvider>
                    </SnackbarProvider>
                  </ArticleProvider>
                </StrategyOverviewCardsProvider>
              </QuestionStepProvider>
            </CalendarArticleProvider>
          </EditResourceProvider>
        </WindowWidthProvider>
      </AuthProvider>
    </ThemeProvider>
  </ApolloProvider>
)

export const onRouteUpdate = state => {
  if (state.location && state.location.state)
    window.location.previousPath = state.prevLocation
}
